export default __webpack_public_path__ + "static/media/center.305520e8.jpg";